<template>
  <div v-show="isSyncPaused" class="fixed bottom-0 left-[calc(50vw-15vw)] z-20 w-[30vw]">
    <MessageNotification variant="custom" class="w-full">
      <div class="rounded-lg bg-red-100 py-4 text-center text-lg text-red-600">
        接続できません。再度接続中です。
      </div>
    </MessageNotification>
  </div>
</template>

<script setup lang="ts">
import { useSharedWorker } from '@/composables/useSharedworker'
import { onMounted, ref } from 'vue'
import MessageNotification from '@/components/MessageNotification.vue'

const worker = useSharedWorker()

const isSyncPaused = ref(false)

onMounted(async () => {
  for (;;) {
    await worker.waitState('SyncPaused')

    const snapshot = await worker.getSnapshot()
    isSyncPaused.value = snapshot.context.error?.isNetworkError ?? false

    await worker.waitState('SyncRunning', 'closed', 'error', 'initializing', 'loading')
    isSyncPaused.value = false
  }
})
</script>
